import { ReportMimeType } from "../../../../common/utils/report_callback";
import { ReportFvsDinamicoFilters } from "../../domain/models/report_fvs_dinamico_filters";
import { ReportData } from "../../domain/models/report_data";
import { IReportsRepository } from "../../domain/repositories/reports_repository";
import { IReportsService } from "../services/reports_service";
import { GetReportJobStatusResponse } from "../daos/read/get_report_job_status";
import { GetReportObraChecklistResponse } from "../daos/read/get_report_obra_checklist";

/**
 * IReportsRepository
 */

export class ReportsRepository implements IReportsRepository {
  constructor(
    private readonly service: IReportsService,
  ) { }

  async getRelatorioFuncionarioTreinamento(
    requiredMimeType: ReportMimeType | null,
    idAvaliacaoTreinamento: number,
    exibirConteudoProgramatico: boolean,
    instrutorAssinatura: number | null,
  ): Promise<ReportData> {
    const response = await this.service.getRelatorioFuncionarioTreinamento({
      requiredMimeType,
      idAvaliacaoTreinamento,
      exibirConteudoProgramatico,
      instrutorAssinatura,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getRelatorioAvaliacaoHabilidade(
    requiredMimeType: ReportMimeType | null,
    idAvaliacaoHabilidade: number,
  ): Promise<ReportData> {
    const response = await this.service.getRelatorioAvaliacaoHabilidade({
      requiredMimeType,
      idAvaliacaoHabilidade
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getRelatorioCadastroFuncionario(
    requiredMimeType: ReportMimeType | null,
    idFuncionario: number,
  ): Promise<ReportData> {
    const response = await this.service.getRelatorioCadastroFuncionario({
      requiredMimeType,
      idFuncionario,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getRelatorioCargos(
    requiredMimeType: ReportMimeType | null,
    idCargo: number | null,
  ): Promise<ReportData> {
    const response = await this.service.getRelatorioCargos({ requiredMimeType, idCargo });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportFuncionarios(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    nome: number[] | null,
    status: number[] | null,
    setor: string[] | null,
    filial: string[] | null,
    centroCusto: number[] | null,
    dataAdmissaoInicio: Date | null,
    dataAdmissaoFim: Date | null,
    dataDemissaoInicio: Date | null,
    dataDemissaoFim: Date | null,
    dataFeriasInicio: Date | null,
    dataFeriasFim: Date | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportFuncionarios({
      requiredMimeType,
      idUsuario,
      nome,
      status,
      setor,
      filial,
      dataAdmissaoInicio,
      dataAdmissaoFim,
      dataDemissaoInicio,
      dataDemissaoFim,
      centroCusto,
      dataFeriasInicio,
      dataFeriasFim,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportTreinamentos(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    nome: number[] | null,
    status: number[] | null,
    dataTreinamentoInicio: Date | null,
    dataTreinamentoFim: Date | null,
    centroCusto: number[] | null,
    eficaz: number[] | null,
    treinamentos: number[] | null,
    cargos: number[] | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportTreinamentos({
      requiredMimeType,
      idUsuario,
      nome,
      status,
      dataTreinamentoInicio,
      dataTreinamentoFim,
      centroCusto,
      eficaz,
      treinamentos,
      cargos,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportDocumentos(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    funcionario: number[] | null,
    statusDocumento: number | null,
    centroCusto: number[] | null,
    situacao: number | null,
    statusFuncionario: number | null,
    dataVencimentoInicio: Date | null,
    dataVencimentoFim: Date | null,
    dataEmissaoInicio: Date | null,
    dataEmissaoFim: Date | null
  ): Promise<ReportData> {
    const response = await this.service.getReportDocumentos({
      requiredMimeType,
      idUsuario,
      funcionario,
      statusDocumento,
      centroCusto,
      situacao,
      statusFuncionario,
      dataVencimentoInicio,
      dataVencimentoFim,
      dataEmissaoInicio,
      dataEmissaoFim,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportTreinamentoFuncionario(
    requiredMimeType: ReportMimeType | null,
    dataRealizacao: Date,
    local: string,
    instrutor: string,
    conteudoProgramatico: string,
    assinatura: number | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportTreinamentoFuncionario({
      requiredMimeType,
      dataRealizacao,
      local,
      instrutor,
      conteudoProgramatico,
      assinatura,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportTreinamentoFuncionarioTerc(
    requiredMimeType: ReportMimeType | null,
    dataRealizacao: Date,
    local: string,
    instrutor: string,
    conteudoProgramatico: string,
  ): Promise<ReportData> {
    const response = await this.service.getReportTreinamentoFuncionarioTerc({
      requiredMimeType,
      dataRealizacao,
      local,
      instrutor,
      conteudoProgramatico,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportFolhaPagamento(
    requiredMimeType: ReportMimeType | null,
    titulo: string | null,
    subcontas: number[] | null,
    folhaPagamentos: number[] | null,
    centroCustos: number[] | null,
    funcionarios: number[] | null,
    bancoPagamentos: number[] | null,
    status: number[] | null,
    dataPagarDe: Date | null,
    dataPagarAte: Date | null,
    dataPagoDe: Date | null,
    dataPagoAte: Date | null,
    colunas: {
      nro: boolean,
      centroCusto: boolean,
      folhaPagamento: boolean,
      funcionarioFolha: boolean,
      bancoPagamento: boolean,
      notaFiscal: boolean,
      nroDoc: boolean,
      responsavel: boolean,
      status: boolean,
      titulo: boolean,
      subConta: boolean,
      dataPagar: boolean,
      dataPago: boolean,
      valorPagar: boolean,
      valorPago: boolean,
      observacoes: boolean,
    },
  ): Promise<ReportData> {
    const response = await this.service.getReportFolhaPagamento({
      requiredMimeType,
      titulo,
      subcontas,
      folhaPagamentos,
      centroCustos,
      funcionarios,
      bancoPagamentos,
      status,
      dataPagarDe,
      dataPagarAte,
      dataPagoDe,
      dataPagoAte,
      colunas,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportFolhaPagamentoDetalhada(
    requiredMimeType: ReportMimeType | null,
    idUsuario: number,
    folhaPagamentos: number[] | null,
    centroCustos: number[] | null,
    funcionarios: number[] | null,
    cargos: number[] | null,
    dataCadastroDe: Date | null,
    dataCadastroAte: Date | null,
    dataPagamentoDe: Date | null,
    dataPagamentoAte: Date | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportFolhaPagamentoDetalhada({
      requiredMimeType,
      idUsuario,
      folhaPagamentos,
      centroCustos,
      funcionarios,
      cargos,
      dataCadastroDe,
      dataCadastroAte,
      dataPagamentoDe,
      dataPagamentoAte,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }


  async getReportMapaConcretagem(
    requiredMimeType: ReportMimeType | null,
    idObra: number,
    dataInicio: Date | null,
    dataFim: Date | null,
    fornecedores: number[] | null,
    localLancamento: string | null,
    resistencia: string | null,
    nroNotaFiscal: string | null,
    statusRompimento: number,
    enviadoLaboratorio: number,
    colunas: {
      dataConcretagem: boolean,
      tipoDoConcretoSolicitado: boolean,
      slumpSolicit: boolean,
      ensaioDoConcreto: boolean,
      resistMpa: boolean,
      fornecedor: boolean,
      nroDoCarro: boolean,
      nroNotaFiscal: boolean,
      saidaUsina: boolean,
      entObra: boolean,
      inicioLanc: boolean,
      finalLanc: boolean,
      qtdeM3: boolean,
      slump: boolean,
      localDeLancamento: boolean,
      dataDeEnvioDaObra: boolean,
      laboratorio: boolean,
      nroCorpoDeProva: boolean,
      nroLote: boolean,
      instrucaoDeRompimento: boolean,
      enviadoParaOLaboratorio: boolean,
      dataDeEnvioParaOLaboratorio: boolean,
      dozeHoras: boolean,
      dataDozeHoras: boolean,
      quatroDias: boolean,
      dataQuatroDias: boolean,
      seteDias: boolean,
      dataSeteDias: boolean,
      quatorzeDias: boolean,
      dataQuatorzeDias: boolean,
      vinteUmDias: boolean,
      dataVinteUmDias: boolean,
      vinteOitoDias: boolean,
      dataVinteOitoDias: boolean,
      cinquentaSeisDias: boolean,
      dataCinquentaSeisDias: boolean,
      sessentaTresDias: boolean,
      dataSessentaTresDias: boolean,
      outrasIdades1: boolean,
      dataOutrasIdades1: boolean,
      outrasIdades2: boolean,
      dataOutrasIdades2: boolean,
      outrasIdades3: boolean,
      dataOutrasIdades3: boolean,
      aprovado: boolean,
      responsavelPelaAprovacao: boolean,
      dataDaAprovacao: boolean,
      observacao: boolean,
    },
  ): Promise<ReportData> {
    const response = await this.service.getReportMapaConcretagem({
      requiredMimeType,
      idObra,
      dataInicio,
      dataFim,
      fornecedores,
      localLancamento,
      resistencia,
      nroNotaFiscal,
      statusRompimento,
      enviadoLaboratorio,
      colunas,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportPlanoQualidadeObra(
    requiredMimeType: ReportMimeType | null,
    idObra: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportPlanoQualidadeObra({
      requiredMimeType,
      idObra,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportControleSustentabilidade(
    requiredMimeType: ReportMimeType | null,
    idObra: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportControleSustentabilidade({
      requiredMimeType,
      idObra,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportMonitoramentoChecklist(
    idObra: number,
    idUsuario: number,
    area: string | null,
    statusArea: string | null,
    servico: string | null,
    statusServico: string | null,
    dataAberturaDe: Date | null,
    dataAberturaAte: Date | null,
    dataEncerramentoDe: Date | null,
    dataEncerramentoAte: Date | null,
    statusVerificacao: string | null,
    statusItemChecklist: string | null,
    empresaTercerizadas: string | null,
    funcionarios: string | null,
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportMonitoramentoChecklist({
      idObra,
      idUsuario,
      area,
      statusArea,
      servico,
      statusServico,
      dataAberturaDe,
      dataAberturaAte,
      dataEncerramentoDe,
      dataEncerramentoAte,
      statusVerificacao,
      statusItemChecklist,
      empresaTercerizadas,
      funcionarios,
      requiredMimeType,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportObraChecklist(
    requiredMimeType: ReportMimeType | null,
    idChecklistArea: number,
    area: string,
    servicos: string | null,
  ): Promise<GetReportObraChecklistResponse> {
    return await this.service.getReportObraChecklist({
      requiredMimeType,
      idChecklistArea,
      area,
      servicos,
    });
  }

  async getReportJobStatus(operacaoId: string): Promise<GetReportJobStatusResponse> {
    return await this.service.getReportJobStatus({ operacaoId });
  }

  async getReportChecklistArea(
    requiredMimeType: ReportMimeType | null,
    idInspecaoObra: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportChecklistArea({
      requiredMimeType,
      idChecklistArea: idInspecaoObra,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportChecklistEntregaLista(
    requiredMimeType: ReportMimeType | null,
    idChecklistEntrega: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportChecklistEntregaLista({
      requiredMimeType,
      idChecklistEntrega,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }


  async getReportPlanoAuditoria(
    IdAuditoria: number, requiredMimeType: ReportMimeType | null
  ): Promise<ReportData> {
    const response = await this.service.getReportPlanoAuditoria({ IdAuditoria, requiredMimeType });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportListaChecklistServico(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportListaChecklistServico({
      requiredMimeType,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportListaChecklistServicoItem(
    requiredMimeType: ReportMimeType | null,
    idChecklistServico: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportListaChecklistServicoItem({
      requiredMimeType,
      idChecklistServico,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportListaFornecedor(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportListaFornecedor({
      requiredMimeType,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  //#region Qualidade 
  async getReportAcoesPreventivas(
    IdAcaoQualidade: number,
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportAcoesPreventivas({ IdAcaoQualidade, requiredMimeType });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }


  async getReportAcoesCorretivas(
    IdAcaoQualidade: number, requiredMimeType: ReportMimeType | null
  ): Promise<ReportData> {
    const response = await this.service.getReportAcoesCorretivas({ IdAcaoQualidade, requiredMimeType });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportProcessosRiscos(
    requiredMimeType: ReportMimeType | null, IdItemProcesso: number
  ): Promise<ReportData> {
    const response = await this.service.getReportProcessosRiscos({ requiredMimeType, IdItemProcesso });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportCronograma(
    requiredMimeType: ReportMimeType | null, DataPrevista: Date | null,
    DataRealizada: Date | null
  ): Promise<ReportData> {
    const response = await this.service.getReportCronograma({ requiredMimeType, DataPrevista, DataRealizada });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportProvisaoRecursos(
    requiredMimeType: ReportMimeType | null, DataPrevista: Date | null,
    DataRealizada: Date | null
  ): Promise<ReportData> {
    const response = await this.service.getReportProvisaoRecursos({ requiredMimeType, DataPrevista, DataRealizada });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  //#endregion

  async getReportServicoProduto(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportServicoProduto({
      requiredMimeType,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportRequisicaoCompra(
    requiredMimeType: ReportMimeType | null,
    idRequisicaoCompra: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportRequisicaoCompra({
      requiredMimeType,
      idRequisicaoCompra,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportColetaPreco(
    requiredMimeType: ReportMimeType | null,
    idColetaPreco: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportColetaPreco({
      requiredMimeType,
      idColetaPreco,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportOrdemCompra(
    requiredMimeType: ReportMimeType | null,
    idOrdemCompra: number
  ): Promise<ReportData> {
    const response = await this.service.getReportOrdemCompra({
      requiredMimeType,
      idOrdemCompra,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportOrdemCompras(
    requiredMimeType: string | null,
    idUsuario: number,
    ordemCompras: number[] | null,
    centroCustos: number[] | null,
    status: number,
    fornecedores: number[] | null,
    dataDe: Date | null,
    dataAte: Date | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportOrdemCompras({
      requiredMimeType,
      idUsuario,
      ordemCompras,
      centroCustos,
      status,
      fornecedores,
      dataDe,
      dataAte,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportOrdemComprasLote(
    centroCusto: number,
    fornecedores: number[] | null,
    status: number,
    competencia: Date,
  ): Promise<ReportData> {
    const response = await this.service.getReportOrdemComprasLote({
      centroCusto,
      fornecedores,
      status,
      competencia,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportGedInterno(
    requiredMimeType: string | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportGedInterno({
      requiredMimeType,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportGedExterno(
    requiredMimeType: string | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportGedExterno({
      requiredMimeType,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  //#region  Comercial Reports

  async getReportNovosNegociosLista(
    request: {
      requiredMimeType: ReportMimeType | null;
      centroCusto?: string | null;
      titulo?: string | null;
      status?: string | null;
      dataDe?: Date | null;
      dataAte?: Date | null;
      colunas?: {
        nroNegocio: boolean;
        data: boolean;
        cliente: boolean;
        cidade: boolean;
        telefone: boolean;
        nroEdital: boolean;
        centroCusto: boolean;
        informacoes: boolean;
      } | null
    }
  ): Promise<ReportData> {
    const response = await this.service.getReportNovosNegociosLista(request);
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportNovosNegocios(
    idNovosNegocios: number,
    requiredMimeType: ReportMimeType,
  ): Promise<ReportData> {
    const response = await this.service.getReportNovosNegocios({ idNovosNegocios, requiredMimeType });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  // INICIO VITOR

  async getReportSatisfacaoClientePesquisa(
    requiredMimeType: string | null,
    idPesquisaSatisfacaoCliente: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportSatisfacaoClientePesquisa({
      requiredMimeType,
      idPesquisaSatisfacaoCliente,
    });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  // FIM VITOR

  //#endregion


  //#region Financeiro Reports

  async getReportContaPagar(
    idContasPagar: number,
    requiredMimeType: ReportMimeType,
  ): Promise<ReportData> {
    const response = await this.service.getReportContaPagar({ idContasPagar, requiredMimeType });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportContaReceber(
    idContasReceber: number,
    requiredMimeType: ReportMimeType,
  ): Promise<ReportData> {
    const response = await this.service.getReportContaReceber({ idContasReceber, requiredMimeType });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportContasPagarAnalitico(
    request: {
      requiredMimeType: ReportMimeType,
      centroCusto?: string | null;
      subconta?: string | null;
      titulo?: string | null;
      fornecedor?: string | null;
      ordemCompra?: string | null;
      dataPagarDe?: Date | null;
      dataPagarAte?: Date | null;
      dataPagoDe?: Date | null;
      dataPagoAte?: Date | null;
      status?: string | null;
      tipoConta?: string | null;
      nro?: string | null;
      notaFiscal?: string | null;
      responsavel?: string | null;
      funcionarioFolha?: string | null;
      idUsuario?: number | null;
      medicao?: string | null;
      produtosServicos?: string | null;
      formaPagamento?: string | null;
      dataCriacaoDe?: Date | null;
      dataCriacaoAte?: Date | null;
      dataCompetenciaDe?: Date | null;
      dataCompetenciaAte?: Date | null;
      bancoPagamento?: string | null;
      ordenacao?: number | null;
      colunas?: {
        nroContasPagar: boolean;
        centroCusto: boolean,
        ordemCompra: boolean,
        fornecedor: boolean,
        bancoPagamento: boolean,
        notaFiscal: boolean,
        nroDocumento: boolean,
        responsavel: boolean,
        status: boolean,
        titulo: boolean,
        subconta: boolean,
        dataPagar: boolean,
        dataPago: boolean,
        valorPagar: boolean,
        valorPago: boolean,
        funcionarioFolha: boolean,
        contaBancaria: boolean,
        observacao: boolean,
        notaFiscalEspecial: boolean,
        bdi: boolean,
        nroMedicao: boolean,
        totalBdi: boolean,
        formaPagamento: boolean,
        informacaoGeral: boolean,
        bdi2: boolean,
        totalBdi2: boolean,
        dataCriacao: boolean,
        dataCompetencia: boolean
      } | null

    }
  ): Promise<ReportData> {
    const response = await this.service.getReportContasPagarAnalitico(request);
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportContasReceberAnalitico(
    request: {
      requiredMimeType: ReportMimeType | null
      centroCusto?: string | null,
      titulo?: string | null,
      dataReceberDe?: Date | null
      dataReceberAte?: Date | null,
      dataRecebidoDe?: Date | null,
      dataRecebidoAte?: Date | null,
      status: string | null,
      tipoConta?: string | null,
      idUsuario?: number | null,
      subconta?: string | null,
      cliente?: string | null,
      nroContratoFinanceiro?: number | null,
      dataCriacaoDe?: Date | null,
      dataCriacaoAte?: Date | null,
      dataCompetenciaDe?: Date | null,
      dataCompetenciaAte?: Date | null,
      ordenacao?: number | null,
      colunas?: {
        nroContasPagar: boolean,
        centroCusto: boolean,
        bancoPagamento: boolean,
        notaFiscal: boolean,
        nroDocumento: boolean,
        status: boolean,
        titulo: boolean,
        dataPagar: boolean,
        dataPago: boolean,
        valorPagar: boolean,
        valorPago: boolean,
        observacao: boolean,
        subconta: boolean,
        cliente: boolean,
        nroContratoFinanceiro: boolean,
        multa: boolean,
        juros: boolean,
        bdi: boolean,
        bdi2: boolean,
        bdiTotal: boolean,
        bdiTotal2: boolean,
        dataCriacao: boolean,
        dataCompetencia: boolean
      } | null
    }
  ): Promise<ReportData> {
    const response = await this.service.getReportContasReceberAnalitico(request);
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportContratoFinanceiroLista(requiredMimeType: ReportMimeType,): Promise<ReportData> {
    const response = await this.service.getReportContratoFinanceiroLista({ requiredMimeType });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportContratoFinanceiroIndividual(
    idContratoFinanceiro: number,
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportContratoFinanceiroIndividual({ idContratoFinanceiro, requiredMimeType });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportSaldoBancarioLista(
    requiredMimeType: ReportMimeType,
    idBancoPagamento?: number,
    dataDe?: Date | null,
    dataAte?: Date | null,
    tipoMovimento?: string | null,
    idUsuario?: number | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportSaldoBancarioLista({
      idBancoPagamento: idBancoPagamento,
      dataDe: dataDe ?? undefined,
      dataAte: dataAte ?? undefined,
      tipoMovimento: tipoMovimento ?? undefined,
      idUsuario: idUsuario ?? undefined,
      requiredMimeType,
    });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportRateioGeralLista(
    requiredMimeType: ReportMimeType,
    numeroConta?: string | null,
    centroCustos?: string | null,
    fornecedores?: string | null,
    ordemCompras?: string | null,
    medicoes?: string | null,
    funcionarios?: string | null,
    valorPago?: number | null,
    dataDe?: Date | null,
    dataAte?: Date | null,
    idUsuario?: number | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportRateioGeralLista({
      requiredMimeType,
      numeroConta,
      centroCustos,
      fornecedores,
      ordemCompras,
      medicoes,
      funcionarios,
      valorPago,
      dataDe,
      dataAte,
      idUsuario,
    });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }


  async getReportFluxoCaixaLista(
    requiredMimeType: ReportMimeType,
    idsBancoPagamento: string | null,
    idsCentroCusto: string | null,
    statusPagamento: number | null,
    statusRecebimento: number | null,
    dataDe: Date | null,
    dataAte: Date | null,
    idFornecedor: number | null,
    idCliente: number | null,
    isEstoque?: boolean
  ): Promise<ReportData> {
    const response = await this.service.getReportFluxoCaixaLista(
      {
        requiredMimeType,
        idsBancoPagamento,
        idsCentroCusto,
        statusPagamento,
        statusRecebimento,
        dataDe,
        dataAte,
        idFornecedor,
        idCliente,
        isEstoque
      });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };

  }


  //#endregion

  //#region Administração Reports

  async getReportPermissaoAcesso(
    requiredMimeType: ReportMimeType
  ): Promise<ReportData> {
    const response = await this.service.getReportPermissaoAcesso({ requiredMimeType });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportLogAcessoSistema(
    requiredMimeType: ReportMimeType,
    idUsuario: number,
    dataDe: Date | null,
    dataAte: Date | null,

  ): Promise<ReportData> {
    const response = await this.service.getReportLogAcessoSistema({ requiredMimeType, idUsuario, dataDe, dataAte });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }


  //#endregion

  //#region DiarioObra
  async getReportDiarioObraIndividual(
    requiredMimeType: ReportMimeType,
    IdDiarioObra: number,

  ): Promise<ReportData> {
    const response = await this.service.getReportDiarioObraIndividual({ requiredMimeType, IdDiarioObra });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  //#endregion

  //#region Tercerizacao
  async getReportListaFuncionariosT(
    requiredMimeType: ReportMimeType,

  ): Promise<ReportData> {
    const response = await this.service.getReportListaFuncionariosT({ requiredMimeType });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }
  async getReportFuncionarioTreinamentoTerc(
    requiredMimeType: ReportMimeType,
    idFuncionarioTreinamento: number
  ): Promise<ReportData> {
    const response = await this.service.getReportFuncionarioTreinamentoTerc({ requiredMimeType, idFuncionarioTreinamento });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportMedicaoTerceirizacao(
    requiredMimeType: ReportMimeType,
    IdMedicaoTerceirizacao: number
  ): Promise<ReportData> {
    const response = await this.service.getReportMedicaoTerceirizacao({ requiredMimeType, IdMedicaoTerceirizacao });
    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  //#endregion

  async getReportAssistenciaTecnica(
    requiredMimeType: ReportMimeType | null,
    codigo: number | null,
    nroChamado: string | null,
    status: number | null,
    dataAbertura: (Date | null)[] | null,
    unidade: string | null,
    procedente: number[],
    categoria: string[],
    resolvido: number[],
    dataEncerramento: (Date | null)[] | null,
    clientes: number[],
    centroCustos: number[],
    prioridade: number[],
  ): Promise<ReportData> {
    const response = await this.service.getReportAssistenciaTecnica({
      requiredMimeType,
      codigo,
      nroChamado,
      status,
      dataAbertura,
      unidade,
      procedente,
      categoria,
      resolvido,
      dataEncerramento,
      clientes,
      centroCustos,
      prioridade,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportAssistenciaTecnicaBasico(
    requiredMimeType: string | null,
    idAssistenciaTecnica: number
  ): Promise<ReportData> {
    const response = await this.service.getReportAssistenciaTecnicaBasico({
      requiredMimeType,
      idAssistenciaTecnica,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }

  async getReportAssistenciaTecnicaCompleto(
    requiredMimeType: string | null,
    idAssistenciaTecnica: number
  ): Promise<ReportData> {
    const response = await this.service.getReportAssistenciaTecnicaCompleto({
      requiredMimeType,
      idAssistenciaTecnica,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }
    return { ...response.data };
  }


  //#region ENTREGA OBRA CLIENTE

  async getReportEntregaObraClienteSimples(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraCliente: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportEntregaObraClienteSimples({
      requiredMimeType,
      idEntregaObraCliente,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportEntregaObraClienteFotografico1(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraCliente: number,
    retrabalhos?: string[],
  ): Promise<ReportData> {
    const response = await this.service.getReportEntregaObraClienteFotografico1({
      requiredMimeType,
      idEntregaObraCliente,
      retrabalhos,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportEntregaObraClienteFotografico2(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraCliente: number,
    retrabalhos?: string[],
  ): Promise<ReportData> {
    const response = await this.service.getReportEntregaObraClienteFotografico2({
      requiredMimeType,
      idEntregaObraCliente,
      retrabalhos,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportEntregaObraClienteGeral(
    requiredMimeType: ReportMimeType | null,
    idEntregaObra: number,
    status?: number[] | null,
    vistorias?: number[] | null,
    clientes?: number[] | null,
    unidades?: number[] | null,
    checklists?: number[] | null,
    localVistorias?: number[] | null,
    dataInspecaoDe?: Date | null,
    dataInspecaoAte?: Date | null,
    idUsuario?: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportEntregaObraClienteGeral({
      requiredMimeType,
      idEntregaObra,
      status,
      vistorias,
      clientes,
      unidades,
      checklists,
      localVistorias,
      dataInspecaoDe,
      dataInspecaoAte,
      idUsuario,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportEntregaObraClienteLote(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraCliente: number,
    idsCliente?: number[],
    retrabalhos?: string[],
  ): Promise<ReportData> {
    const response = await this.service.getReportEntregaObraClienteLote({
      requiredMimeType,
      idEntregaObraCliente,
      idsCliente,
      retrabalhos,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportEntregaObraClienteTermo(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraClienteTermo: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportEntregaObraClienteTermo({
      requiredMimeType,
      idEntregaObraClienteTermo,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  //#endregion

  //#region Controle Estoque
  async getReportEntradaProduto(
    requiredMimeType: ReportMimeType | null,
    IdUsuario: number,
    Fornecedores?: number[],
    Produtos?: number[],
    NumeroNotaFiscal?: string | null,
    CentroCustos?: number[],
    DataInicio?: Date | null,
    DataFinal?: Date | null
  ): Promise<ReportData> {
    const response = await this.service.getReportEntradaProduto({ requiredMimeType, IdUsuario, Fornecedores, Produtos, NumeroNotaFiscal, CentroCustos, DataInicio, DataFinal });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }
  async getReportSaidaProduto(
    requiredMimeType: ReportMimeType | null,
    IdUsuario: number,
    Funcionario?: number | null,
    Produtos?: number | null,
    CentroCustos?: number[],
    CentroCustosDestino?: number[],
    DataInicio?: Date | null,
    DataFinal?: Date | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportSaidaProduto({ requiredMimeType, IdUsuario, Funcionario, Produtos, CentroCustos, CentroCustosDestino, DataInicio, DataFinal });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }
  async getReportControleEstoque(
    requiredMimeType: ReportMimeType | null,
    IdControleEstoque: number,
    IdUsuario: number
  ): Promise<ReportData> {
    const response = await this.service.getReportControleEstoque({ requiredMimeType, IdControleEstoque, IdUsuario });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }
  //#endregion

  async getReportMaquinasEquip(
    requiredMimeType: ReportMimeType | null
  ): Promise<ReportData> {
    const response = await this.service.getReportMaquinasEquip({ requiredMimeType });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportMateriaisControlados(
    requiredMimeType: ReportMimeType | null
  ): Promise<ReportData> {
    const response = await this.service.getReportMateriaisControlados({ requiredMimeType });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportTreinamentosFuncionarios(
    requiredMimeType: ReportMimeType | null,
    centroCustos: number[] | null,
    dataRealizado: (Date | null)[] | null,
    funcionarios: number[] | null,
    dataAvaliacao: (Date | null)[] | null,
    eficaz: number[] | null,
    idUsuario: number,
  ): Promise<ReportData> {
    const response = await this.service.getReportTreinamentosFuncionarios({
      requiredMimeType,
      centroCustos,
      dataRealizado,
      funcionarios,
      dataAvaliacao,
      eficaz,
      idUsuario,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }
  async getReportListaDisciplinas(
    requiredMimeType: ReportMimeType | null, IdProjeto: number
  ): Promise<ReportData> {
    const response = await this.service.getReportListaDisciplinas({ requiredMimeType, IdProjeto });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportPlanoProjeto(
    requiredMimeType: ReportMimeType | null, IdProjeto: number
  ): Promise<ReportData> {
    const response = await this.service.getReportPlanoProjeto({ requiredMimeType, IdProjeto });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportObraServicosControlados(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportObraServicosControlados({ requiredMimeType });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }

  async getReportComprasRelatorioCompras(
    requiredMimeType: ReportMimeType | null,
    centroCustos: number[] | null,
    titulo: string | null,
    ordemCompras: number[] | null,
    subcontas: number[] | null,
    fornecedores: number[] | null,
    dataOC: (Date | null)[] | null,
    produtoServicos: number[] | null,
    dataPago: (Date | null)[] | null,
    statusOC: number[] | null,
    idUsuario: number | null,
  ): Promise<ReportData> {
    const response = await this.service.getReportComprasRelatorioCompras({
      requiredMimeType,
      centroCustos,
      titulo,
      ordemCompras,
      subcontas,
      fornecedores,
      dataOC,
      produtoServicos,
      dataPago,
      statusOC,
      idUsuario
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }
  async getReportIndicadores(
    requiredMimeType: ReportMimeType | null
  ): Promise<ReportData> {
    const response = await this.service.getReportIndicadores({
      requiredMimeType,
    });

    if (response.status !== "ok") {
      throw new Error("Falha ao buscar relatorio!");
    }

    return { ...response.data };
  }
  async getReportFvsDinamico(idObra: number, idUsuario: number, filters?: ReportFvsDinamicoFilters): Promise<string> {
    return await this.service.getReportFvsDinamico({ ...filters, idObra, idUsuario });
  }
}
